<template>
  <div>
    <h2>What is History?</h2>
    <p>
      History is the response of a person or people to events and circumstances
      around them.
      <br />
      <br />History is not a dry recitation of dates, events and documents. It
      is people in action and in many cases dealing with issues that people have
      always faced. Read a book of history, a newspaper or website and you will
      likely see the questions have not changed but the fascinating variety of
      answers has.
    </p>
    <h2>Why History Reconsidered?</h2>
    <p>
      Because there are significant historical decisions made and actions taken
      that are worth giving another look or “reconsideration” because they have
      never been examined (such as Gooch’s American Regiment, 1740-1742) or have
      not been examined thoroughly. The way history is reconsidered matters.
      History needs to be made accessible, supported with graphics and pictures
      when possible, while respecting the intelligence of the reader. No dumbing
      down here mislabeled as accessibility!
      <br />
      <br />Sources matter too. Never waste your time on a historical account
      that is unsupported by sources unless the author watched the event happen.
      As a writer who believes in intellectual honesty, it is important to
      document where you found source material. Readers should always be
      supported in their efforts to continue their journey through a subject by
      providing sources and suggested further reading.
      <br />
      <br />I have chosen to focus on military history because I am a lifelong
      student of military history and a retired soldier. It is something I am
      interested in, believe is of value and, perhaps presumptuously, think I
      have some knowledge of, both intellectually and personally. Warfare is a
      terrible thing but from this terrible thing, important and good things
      have come into being or been sustained. The crucible of war has brought
      out the best and worst in human behavior and provided lessons to be
      learned in its execution that apply across the ages, military echelons and
      locations around the world. I hope I can make some small contribution to
      the field with my work.
    </p>
    <p class="lee">– Lee Offen</p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.lee {
  text-align: right;
}
</style>
